<template>
    <div class="Headlines">
        <van-image
        class="Headlines-img"
        :src="img"
        />
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
            <div class="Headlines-box">
                <div class="Headlines-box-Content" :class="List.length - 1 === index ? 'Headlines-box-Content-last':''" v-touch:tap="skip(item.id)" v-for="(item, index) in List" :key="item.id">
                    <van-image
                    class="content-img"
                    radius="10"
                    v-bind:src="item.image"
                    style="float:left"
                    />
                    <div class="Headlines-box-Content-right">
                        <p class="rightTopStyle ellipsis2">{{item.tile}}</p>
                        <p class="rightBottomStyle ellipsis2">{{item.text}}</p>
                    </div>
                </div>
            </div>
        </van-list>
    </div>
</template>
<script>
import {  List, } from 'vant';
import {getAllNewsUrl} from '@culturalRelicsUrl';
import http from '@js/http-ww.js'
export default {
    data(){
        return {
            img: require('../../lib/image/news/1233.png'),
            List:[
                {
                    id:1,
                    image: require('../../lib/image/news/22.png'),
                    tile:"海博头条新闻",
                    text:"但随着时间的推移,以前各朝代的皇帝宝玺存世者已经寥寥无几",
                },
                {
                    id:2,
                    image: require('../../lib/image/news/33.png'),
                    tile:"海博头条新闻",
                    text:"但随着时间的推移,以前各朝代的皇帝宝玺存世者已经寥寥无几",
                },
                {
                    id:3,
                    image: require('../../lib/image/news/44.png'),
                    tile:"海博头条新闻",
                    text:"但随着时间的推移,以前各朝代的皇帝宝玺存世者已经寥寥无几",
                }
            ],
            //分页
            loading: false,
            finished: false,
            requestParams:{
                nodeId: 250,
                page: -1,
                size: 10,
            }
        }
    },
    created() {
        this.List = [];
        // this.getAllNewsList();
    },
    methods: {
        //跳转新闻详情
        skip(id) {
            return () => {
                // console.log(id);
                this.$router.push({ path: "headlinesDetailed",query: {id:id}}).catch(err => {
                    err;
                });
            };
        } ,
        //获取新闻列表
        getAllNewsList(){
            this.requestParams.page++
            http.get(getAllNewsUrl, { 
                params:{
                    // nodeId: 171 ,
                    // offset: this.List.length, 
                    // psize: this.requestParams.psize,
                    ...this.requestParams
                },
                loading: false
            }) 
            .then(res=>{
                // console.log(res)
                const {
                    content : array = []
                } = res.data.data.page;
                this.loading = false;
                //请求的数据组装
                // var List = [];
                array.map(item=>{
                    this.List.push({
                        id:item.id,
                        tile: item.title,
                        text: item.metaDescription,
                        image: item.smallImage
                    })
                    
                })
                // this.List = List;
                this.loading = false;
                if(array.length === 0){
                    this.finished = true;
                }
            })
        },
        onLoad() {
            this.getAllNewsList()
        },
    },
    components: {
        [List.name]: List,
    }
}   
</script>
<style lang="less" scoped>
   .Headlines{
        background:#EFF0FA!important;
        .Headlines-img{
            width: 100%;
            height: 236px;
        }
        .Headlines-box{
            position: relative;
            top:-44px;
            margin-bottom: -40px;
            padding: 0 7px;
            .Headlines-box-Content{
                margin-bottom: 14px;
                background:rgba(255,255,255,1);
                box-shadow:0px 1px 8px 0px rgba(212,206,218,0.5);
                border-radius:5px;
                padding: 16px 20px 16px 10px;
                overflow: auto;
                zoom: 1;
                .content-img{
                    width: 116px;
                    height: 84px;
                }
                .Headlines-box-Content-right{
                    margin-left: 140px;
                    .rightTopStyle{
                        color:rgba(53,58,62,1);
                        line-height:20px;
                        font-size: 14px;
                    }
                    .rightBottomStyle{
                        font-size:12px;
                        font-weight:500;
                        color:rgba(152,156,165,1);
                        line-height:22px;
                        overflow: hidden;
                        display: -webkit-box;
                        -webkit-box-orient:vertical;
                        -webkit-line-clamp:2;
                    }
                }
            }
            .Headlines-box-Content-last{
                margin: 0 !important;
            }
        }
   }
</style>